import React, { useEffect, useState } from "react";
import UserPanelTitle from "../UserPanelTitle/UserPanelTitle";
import { axiosConfig } from "../../Configuration/axios/axiosConfiguration";
import "./UserCourses.css";
import { Link } from "react-router-dom";

export default function UserCourses() {
	const [courses, setCourses] = useState([]);

	useEffect(() => {
		axiosConfig.get("/api/User/Courses").then((res) => {
			setCourses(res.data);
		});
	}, []);

	return (
		<div className="user-courses">
			<UserPanelTitle title="دوره های خریداری شده" />
			<div className="user-courses-table">
				<table>
					<thead>
						<tr>
							<th>نام محصول</th>
							<th>لینک</th>
						</tr>
					</thead>
					<tbody>
						{courses.map((course) => {
							return (
								<tr className="table-item">
									<td>{course.title}</td>
									<td>
										<div className="d-flex justify-center">
											<Link
												target="blank"
												to={`/course/${course.title}`}
												className="table-btn text-center w-35"
											>
												صفحه محصول
											</Link>
										</div>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
			<div className="user-order-table-responsive">
				<table>
					<tbody>
						{courses.map((course) => {
							return (
								<tr className="table-item">
									<td>{course.title}</td>
									<td>
										<Link
											target="blank"
											to={`/course/${course.title}`}
											className="table-btn"
										>
											صفحه محصول
										</Link>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
		</div>
	);
}
